export default __webpack_public_path__ + "static/media/detail_big_12_1.4cf95772.jpg";